import './App.css';
import NavBar from './Components/NavBar';
import HomePage from './Pages/HomePage';

function App() {

  return (
    <>
      <NavBar />
      <HomePage />
    </>
  );
}

export default App;
